<template>
  <div class="bank-statement">
    <div id="myaccount">
      <h1 class="pad_left">Hesap Özetim</h1>
      <div id="comp-myContent">
        <div id="comp-balance">
          <div id="bet_balance">
            <div class="account_sheet">
              <div class="balance-box cf">
                <div class="balance-title">
                  Bahis hesabı bakiyesi
                </div>
                <div class="balance-count">
                  {{ session.balance | toMoney(session.currency) }}
                </div>
              </div>
            </div>
          </div>
          <div id="bet_balance">
            <div class="account_sheet">
              <div class="balance-box cf">
                <div class="balance-title">
                  Bonus hesabı bakiyesi
                </div>
                <div class="balance-count">
                  {{ session.bonus | toMoney(session.currency) }}
                </div>
              </div>
            </div>
          </div>
          <div id="bet_balance">
            <div class="account_sheet">
              <div class="balance-box cf">
                <div class="balance-title">
                  Toplam hesap bakiyesi
                </div>
                <div class="balance-count">
                  {{ Number(session.bonus) + Number(session.balance) | toMoney(session.currency) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <table class="tab-box">
          <tbody>
          <tr>
            <td class="tab-select" v-for="navFilterItem in navFilterData" :key="navFilterItem.id"
                :class="navFilterItem.id === selectedNavFilter.id ? 'on' : ''"
                @click="getNavFilter(navFilterItem)">
              <a>{{ navFilterItem.title }}</a>
            </td>
            <td class="tab-empty">&nbsp;</td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="tab-cont">
                <div class="drop-box">
                  <div class="drop-layer">
                    <div class="button-drop" @click="dropOpen = !dropOpen; dateSelection = false">
                      <div class="drop-title">{{ dropTitle.title }}<i class="ti-angle-double-down"></i></div>
                    </div>
                    <ul class="drop-items" v-if="dropOpen">
                      <li v-for="day in dayFilterData" :key="day.id" @click="dayFilter(day)">
                        <a>{{ day.title }}</a>
                      </li>
                      <li @click="dateSelection = !dateSelection; dropOpen = !dropOpen">
                        <a>Donem Sec ...</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="dateSelection">
            <td colspan="4">
              <div class="tab-cont">
                <div id="datePicker">
                  Buradan&nbsp;
                  <DatePicker v-model="datePicker.from" placeholder="donem sec" format="yyyy-MM-dd"
                              @closed="rangeDate()" :language="tr" :monday-first="true"
                              :full-month-name="true"></DatePicker>
                  &nbsp;Buraya&nbsp;
                  <DatePicker v-model="datePicker.to" placeholder="donem sec" format="yyyy-MM-dd" @closed="rangeDate()"
                              :language="tr" :monday-first="true" :full-month-name="true"></DatePicker>
                  <span class="text-danger" v-show="datePicker.err">Lutfen iki alanida doldurun.</span>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="panel-head cf">
          <div class="sheet-c1 sheet">
            &nbsp;
          </div>
          <div class="sheet-c2 sheet">
            <a class="uline cursor-pointer" @click="sortDate()">{{ t.betting.title.date }} <span class="sort-i"><i
                :class="sDate ? 'ti-angle-up' : 'ti-angle-down'"></i></span></a>
          </div>
          <div class="sheet-c3 sheet">İşlem Tipi</div>
          <div class="sheet-c4 sheet">&nbsp;</div>
          <div class="sheet-c5 sheet">&nbsp;</div>
          <div class="sheet-c6 sheet">Euro olarak TL</div>
        </div>
        <div class="history-balance-box">

          <div class="new-sheet-header cf" v-for="trans in transactions" :key="trans.id">
            <div class="sheet-c1 sheet">
              <!--<div class="sheet-tab"><span class="sheet-tab-icon">
                  <i class="ti-angle-double-right"></i>
                  </span>3006973</div>-->&nbsp;
            </div>
            <div class="sheet-c2 sheet">
              <b>{{ trans.addedAt | moment('D MMM ddd', session.timezone) | slimiter(10) }}</b>&nbsp;
              <i>{{ trans.addedAt | moment('HH:MM', session.timezone) | slimiter(10) }}</i>
            </div>
            <div class="sheet-c3 sheet">{{ trans.info }}</div>
            <div class="sheet-c4 sheet">&nbsp;</div>
            <div class="sheet-c5 sheet">&nbsp;</div>

            <div class="sheet-c6 sheet" :style="trans.type.operator === '-' ? {color: 'red'} : {color: 'green'}">
              {{ trans.type.operator }}{{ trans.amount | toMoney(session.currency) }}
            </div>
          </div>

        </div>

      </div>
    </div>
    <paginate v-if="pagination" class="mx-3"
              :page-count="pagination.pageCount"
              :page-range="pagination.pageRange"
              :force-page="(pagination.current-1)"
              :initialPage="(pagination.current-1)"
              :margin-pages="2"
              :click-handler="onChangePage"
              :prev-text="t.previous"
              :next-text="t.next"
              :container-class="'pagination float-right'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-class="'page-item'"
              :prev-link-class="'page-link'"
              :next-class="'page-item'"
              :next-link-class="'page-link'"
    >
    </paginate>
  </div>
</template>
s
<script>
import BetSlip from '@/components/sportsbook/BetSlip';
import Paginate from 'vuejs-paginate'
import moment from 'moment'

import DatePicker from 'vuejs-datepicker';
import {tr, en} from 'vuejs-datepicker/dist/locale'

export default {
  name: "bankStatement",
  components: {BetSlip, Paginate, DatePicker},
  data() {
    return {
      session: session,
      pagination: null,
      t: this.$root.t,
      notfound: false,
      transactions: null,
      type: [9, 10, 17],
      sDate: false,
      tr: tr,
      navFilterData: [
        {
          id: 0,
          title: 'Hepsi',
          type: [9, 10, 16, 32, 30, 31, 1, 27, 28, 29, 23, 24, 26, 25, 2, 3, 4, 22, 38, 39, 40, 42, 41, 43, 44, 20, 19]
        },
        {
          id: 1,
          title: 'Bahisler',
          type: [1, 27, 28, 29, 23, 24, 26, 25]
        },
        {
          id: 2,
          title: 'Casino',
          type: [2, 3, 4, 22, 38, 39, 40, 42, 41, 43, 44, 20, 19]
        },
      ],
      selectedNavFilter: {
        id: 0,
        title: 'Hepsi',
        type: [9, 10, 16, 32, 30, 31, 1, 27, 28, 29, 23, 24, 26, 25, 2, 3, 4, 22, 38, 39, 40, 42, 41, 43, 44, 20, 19]
      },
      dayFilterData: [
        {
          id: 0,
          title: 'Son 30 Gun',
          count: 30
        },
        {
          id: 1,
          title: 'Son 15 Gun',
          count: 15
        },
        {
          id: 2,
          title: 'Son 1 Hafta',
          count: 7
        },
        {
          id: 3,
          title: 'Son 1 Yil',
          count: 365
        },
      ],
      dropOpen: false,
      dropTitle: {
        id: 0,
        title: 'Son 30 Gun',
        count: 30
      },
      dateSelection: false,
      datePicker: {
        to: null,
        from: null,
        err: false,
      }
    }
  },
  watch: {
    '$route'() {
      this.fetchTransactions(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.type);
    },
  },
  mounted() {
    this.fetchTransactions(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.type);
  },
  methods: {
    getNavFilter(item) {
      this.selectedNavFilter = item;
      this.fetchTransactions(this.sDate, this.dropTitle.count, this.datePicker, item.type);
    },
    rangeDate() {
      if (this.datePicker.from !== null && this.datePicker.to !== null) {
        this.datePicker.err = false;
        this.fetchTransactions(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.type);
      } else {
        this.datePicker.err = true;
      }
    },
    sortDate(sDate) {
      this.sDate = !this.sDate;
      this.fetchTransactions(this.sDate, this.dropTitle.count, this.datePicker, this.selectedNavFilter.type);
    },
    dayFilter(item) {
          this.datePicker.from = null,
          this.datePicker.to = null,
          this.dropTitle = item;
          this.dropOpen = false;
          this.fetchTransactions(this.sDate, item.count, this.datePicker, this.selectedNavFilter.type);
    },
    onChangePage(page) {
      this.pagination.current = page;
      this.$router.push({query: {page: page}});


      window.scroll(0, 0);
    },
    fetchTransactions(dir, dayCount, dateRange, type) {
      this.$bus.$emit('globalLoader', 1);
      this.$http.get(api + 'api/v1/user/transactions', {
        params: {
          type: type ? type : [9, 10, 16, 23, 24, 25, 26, 27, 28, 29, 32, 30, 31],
          //onlyOrder: 0,
          status: this.$route.query.status,
          page: this.$route.query.page,
          direction: dir ? 'asc' : 'desc',
          rangeDateTime: {
            from: dateRange.from !== null ? moment(dateRange.from).utc().format("YYYY-MM-DD") : moment(moment(new Date()).utc().format()).add(-dayCount, 'd').format('YYYY-MM-DD'),
            to: dateRange.to !== null ? moment(dateRange.to).utc().format("YYYY-MM-DD") : moment().add(2, 'd').format("YYYY-MM-DD")
          },
        }
        //params: this.$route.query
      })
          .then(response => {
            this.pagination = response.body.result.pagination;
            this.transactions = response.body.result.transactions;
            this.$bus.$emit('globalLoader', 0);
            this.notfound = false;
          }, response => {
            this.transactions = [];
            this.pagination = null;
            this.notfound = true;
            this.$bus.$emit('globalLoader', 0);
          })
    }
  }
}
</script>

<style scoped>
.bank-statement .table tr {
  background: #fff;
}

.bank-statement .table tbody tr:nth-child(2n+1) {
  background: #ebebeb;
}

.bank-statement .table td, .bank-statement .table th {
  border-right: 1px solid #ccc;
}

#myaccount {
  padding: 10px;
  background: white;
  border: 1px solid #999999;
  margin: 0;
}

#myaccount h1 {
  padding: 12px 0px 4px 12px;
  margin-bottom: 0px;
  color: #7c7c7c;
  border-bottom: 3px solid #7c7c7c;
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
}

#myaccount h1.pad_left {
  padding: 9px;
}

#comp-myContent {
  padding-top: 10px;
}

.account_sheet {
  background: white;
  width: 100%;
}

#bet_balance {
  margin-bottom: 10px;
}

.balance-box {
  display: flex;
  background: #ebebeb;
  border: 1px solid #ccc;
  padding: 5px;
  font-size: 12px;
  font-weight: 500;
}

.balance-box .balance-title {
  flex: 0 50%;
}

.balance-box .balance-count {
  flex: 0 50%;
  display: flex;
  justify-content: flex-end;
}

#myaccount table.tab-box tr:last-child {
  border: 1px solid #ccc;
}

#myaccount table.tab-box {
  margin-top: 40px;
}

#myaccount .new-sheet-header {
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}

.history-balance-box {
  margin-top: 10px;
}

#datePicker {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/user/bankStatement.vue